import React, { useRef, useCallback, useState, useEffect } from 'react';

import { Form } from '@unform/web';
// import { Container } from './styles';
import { Button, Row, Col } from 'react-bootstrap';
import { useAuth } from '../../../hooks/auth';

import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';
import SelectSync, { IOption } from '../../SelectSync';
import TextArea from '../../TextArea';
import IMotivo from '../../../utils/interface/IMotivo';
import Loading from '../../Loading';
import getResponseErrors from '../../../utils/getResponseErrors';
import { TIPO_MOTIVO } from '../../../utils/funcoes';

interface IEstorno {
  usuario_id: number;
  motivo_id: number;
  descricaoDesconto: string;
  motivo_usuario_id: number;
  dataAtualizacaoAgenda: string;
}

type Props = {
  cprCodigo: number;
  dataAtualizacaoAgenda: string;
  handleFechar(): void;
};

const Estorno: React.FC<Props> = ({
  cprCodigo,
  dataAtualizacaoAgenda,
  handleFechar,
}) => {
  const formRefEstorno = useRef(null);
  const { user } = useAuth();
  const { addToast } = useToast();

  const [optionsMotivo, setOptionsMotivo] = useState<IOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadOptionsMotivo(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IMotivo[]>(
          `/motivos?ativo=true&tipo=${TIPO_MOTIVO.ESTORNO}`,
        );

        const options = response.data.map((op: IMotivo) => ({
          value: op.id.toString(),
          label: op.nome,
        }));

        setOptionsMotivo(options);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar motivos',
          type: 'error',
          description: mensagemErro,
        });
      }
      setLoading(false);
    }
    loadOptionsMotivo();
  }, [addToast]);

  const handleEstorno = useCallback(
    async data => {
      const { motivo, observacao } = data;
      if (motivo === '') {
        addToast({
          type: 'error',
          title: 'Selecione o motivo',
        });
        return;
      }
      if (observacao === '') {
        addToast({
          type: 'error',
          title: 'Observação é um campo obrigatório',
        });
        return;
      }
      setLoading(true);
      try {
        const dadosEstorno: IEstorno = {
          usuario_id: user.id,
          motivo_id: motivo,
          descricaoDesconto: observacao,
          motivo_usuario_id: user.id,
          dataAtualizacaoAgenda,
        };

        await api.post(`/caixa/estornopagamento/${cprCodigo}`, dadosEstorno);
        addToast({
          type: 'success',
          title: 'Estorno realizado com sucesso',
        });
        handleFechar();
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        // const statusErro = error?.response?.status;
        // if (statusErro === 403) {
        //   setExibePermissaoAdmin(true);
        //   setMensagemPermissaoAdmin(mensagemErro);
        // }
        addToast({
          type: 'error',
          title: 'Erro ao executar estorno',
          description: mensagemErro,
        });
      }
      setLoading(false);
    },
    [addToast, cprCodigo, handleFechar, dataAtualizacaoAgenda, user.id],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}
      <Form ref={formRefEstorno} onSubmit={handleEstorno}>
        <p className="mb-2 mt-0">
          Para realizar esse procedimento insira o motivo e uma observação sobre
          o estorno.
        </p>
        <Row className="no-gutters">
          <Col md="12" lg="12" className="form-group pr-2">
            <SelectSync
              name="motivo"
              label="Motivo"
              placeholder="Selecione"
              isClearable={false}
              handleSelectChange={handleOnChangeVazio}
              options={optionsMotivo || [{ label: '', value: '' }]}
            />
          </Col>
        </Row>
        <Row className="no-gutters">
          <Col md="12" lg="12" className="form-group pr-2">
            <TextArea name="observacao" label="Observação" rows={3} />
          </Col>
        </Row>
        <div className="d-flex justify-content-end">
          <Button type="submit" className="mt-2" size="sm">
            Salvar Estorno
          </Button>
        </div>
      </Form>
    </>
  );
};

export default Estorno;
